import { render, staticRenderFns } from "./SubHeaderWithSidebar.vue?vue&type=template&id=0e3d2128&scoped=true&"
import script from "./SubHeaderWithSidebar.vue?vue&type=script&lang=js&"
export * from "./SubHeaderWithSidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e3d2128",
  null
  
)

export default component.exports